import $ from 'jquery'
import selectChoices from './selectChoices'
import OpenAjaxModal from './openAjaxModal'

export default class selectChoicesCannabisBasketDelivery extends selectChoices {
    initialize () {
        this.availableText = this.$element.data('availableText')
        this.someAvailableText = this.$element.data('someAvailableText')
        this.unavailableText = this.$element.data('unavailableText')
        this.submitOnChange = this.$element.data('submitOnChange')
        this.customPharmacyValue = this.$element.data('customPharmacyValue')
        this.customPharmacyModalUrl = this.$element.data('customPharmacyModalUrl')
        this.customPharmacyModalLoadingText = this.$element.data('customPharmacyModalLoadingText')

        super.initialize()

        this.$form = this.$select.closest('form')
        if (this.$form.length > 0) {
            this.$select.on('change', this.handleChange.bind(this))
        }
    }

    handleChange (event) {
        if (this.$select.val() === this.customPharmacyValue) {
            const modal = new OpenAjaxModal(null)
            modal.modalUrl = this.customPharmacyModalUrl
            modal.loadingText = this.customPharmacyModalLoadingText
            modal.loadContent();
            retrun
        }

        if (this.submitOnChange) {
            this.$form.trigger('submit')
        }
    }

    getChoicesOptions () {
        const options = super.getChoicesOptions()
        options.callbackOnCreateTemplates = (strToEl) => {
            return {
                item: this.selectedItemTemplate.bind(this),
                choice: this.choiceTemplate.bind(this),
                choiceGroup: this.choiceGroupTemplate.bind(this)
            }
        }
        return options
    }

    choiceGroupTemplate (choices, data) {
        const classNames = choices.classNames
        const label = data.label
        const disabled = data.disabled
        return $(`
            <div class="${classNames.group} ${(disabled ? classNames.itemDisabled : '')}"
                 role="group" data-group="" data-id="" data-value=""
                 ${(disabled ? 'aria-disabled="true"' : '')}
                >
                <div class="${classNames.groupHeading}">
                    ${label}
                </div>
            </div>
        `).get(0)
    }

    selectedItemTemplate (choices, data) {
        const classNames = choices.classNames

        const classes = [classNames.item]
        if (data.highlighted) {
            classes.push(classNames.highlightedState)
        } else {
            classes.push(classNames.itemSelectable)
        }

        return $(`
            <div class="${classes.join(' ')}"
                 data-id="${data.id}"
                 data-value="${data.value}"
                 ${(data.active ? 'aria-selected="true"' : '')}
                >
                ${this.cannabisBasketDeliveryTemplate(data.customProperties, data.label)}
            </div>
        `).get(0)
    }

    cannabisBasketDeliveryTemplate (properties, fallbackLabel) {
        if (typeof properties !== 'object' || properties == null) {
            return `<span>${fallbackLabel}</span>`
        }
        if (Object.keys(properties).length < 1) {
            return `<span>${fallbackLabel}</span>`
        }
        console.log(properties, fallbackLabel)

        let availableMarker = ''

        if (properties.hasOwnProperty('showAvailability') &&
            properties.hasOwnProperty('allFlowersAvailable') &&
            properties.hasOwnProperty('flowerCount') &&
            properties.hasOwnProperty('flowersAvailable')) {
            const showAvailability = properties.showAvailability || false
            const allFlowersAvailable = properties.allFlowersAvailable || false
            const flowerCount = parseInt(properties.flowerCount, 10)
            const flowersAvailable = parseInt(properties.flowersAvailable, 10)

            if (showAvailability) {
                if (allFlowersAvailable) {
                    availableMarker = this.availableText
                } else {
                    if (flowersAvailable === 0) {
                        availableMarker = this.unavailableText
                    } else {
                        availableMarker = this.someAvailableText.replace('%a%', flowersAvailable).replace('%b%', flowerCount)
                    }
                }
            }
        }

        return `
            <div class="d-flex w-100 justify-content-between">
                <div class="text-truncate">${properties.label}</div>
                <div class="text-truncate text-body-tertiary me-2">${availableMarker}</div>
            </div>
        `
    }

    choiceTemplate (choices, data) {
        const classNames = choices.classNames

        const classes = [classNames.item, classNames.itemChoice]
        if (data.disabled) {
            classes.push(classNames.itemDisabled)
        } else {
            classes.push(classNames.itemSelectable)
        }
        if (data.selected) {
            classes.push(classNames.selectedState)
        }
        if (data.placeholder) {
            classes.push(classNames.placeholder)
        }
        classes.push('pe-0')
        return $(`
            <div class="${classes.join(' ')}" data-choice data-choice-selectable
                data-id="${data.id}"
                data-value="${data.value}"
                role="option"
                >
                ${this.cannabisBasketDeliveryTemplate(data.customProperties, data.label)}
            </div>
        `).get(0)
    }
}
